import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';

import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { getTranslation } from 'common/react/utils/translations';

import { Fixture } from './Fixture';

const { PROVIDER_IDS } = PULSE.app.common.CONSTANTS;
const AUS_TIMEZONE = 'australia';

const broadcasterRegion = () => {
    const timezone = moment.tz.guess(true);
    if (timezone.toLowerCase().split('/')[0] === AUS_TIMEZONE) {
        return true;
    }
    return false;
};

export const FixturesGroup = ({ group, dateKey, broadcastGuideUrl }) => {
    const nav = useSelector(navSelector);

    const reportLabel = PULSE.app.common.url.urlify(
        getTranslation('label.mc.reportTab')
    );

    const mcLink = [
        PROVIDER_IDS.PRE_SEASON,
        PROVIDER_IDS.PREMIERSHIP,
        PROVIDER_IDS.VFL_PREMIERSHIP,
        PROVIDER_IDS.VFL_WOMENS,
        PROVIDER_IDS.WAFL_PREMIERSHIP,
        PROVIDER_IDS.WOMENS,
        PROVIDER_IDS.SANFL_PREMIERSHIP
    ].includes(nav?.competition.providerId);

    const date = moment(dateKey, 'YYYYMMDD');

    return (
        <div className="fixtures__group">
            <div className="fixtures__group-divider">
                <div className="fixtures__group-date">
                    {dateKey === 'TBCPC'
                        ? getTranslation(
                              'label.fixtures.tbc-postponed-cancelled'
                          )
                        : date.format('dddd MMMM D')}
                </div>
            </div>
            {group.map((match) => (
                <ErrorBoundary key={match.id} fallback={<></>}>
                    <Fixture
                        mcLink={mcLink}
                        regionIsAus={broadcasterRegion()}
                        match={match}
                        reportLabel={reportLabel}
                        broadcastGuideUrl={broadcastGuideUrl}
                    />
                </ErrorBoundary>
            ))}
        </div>
    );
};

FixturesGroup.propTypes = {
    group: PropTypes.array.isRequired,
    dateKey: PropTypes.string,
    broadcastGuideUrl: PropTypes.string
};
